const getters = {
  session: (state) => state.session_check,
  gatorDevices: (state) => state.gator_devices,
  historyList: (state) => state.history_list,
  imgList: (state) => state.img_list
}

export default getters
